query BillingHasContracts {
  contractPayments(rowsPerPage: 1) {
    count
  }
  revenueShareReports(rowsPerPage: 1) {
    count
  }
}
